var error = {
  translation: {
    error: {
      coreNotFound: 'Nepodarilo sa načítať základné nastavenia',
      domainNotAllowed: 'Registrácia s emailom z tejto domény nie je povolená',
      emailAlreadyInUse: 'Email je už používaný',
      insufficientPermissions: 'Nedostatočné oprávnenia',
      invalidCurrentPassword: 'Nesprávne aktuálne heslo',
      invalidPermissions: 'Vyberte aspoň jedno oprávnenie',
      invalidUsernameOrPassword: 'Neplatné používateľské meno alebo heslo',
      localRegistrationDisabled: 'Lokálna registrácia je zakázaná administrátorom',
      noInternetConnection: 'Žiadne pripojenie na internet',
      noOidcProfileFound: 'OIDC profil nenájdený',
      policyNotAccepted: 'Prijmite prosím Všeobecné podmienky a Ochrana osobných údajov',
      registrationDisabled: 'Registrácia používateľov je zakázaná administrátorom',
      serverConnectionFailed: 'Pripojenie k serveru zlyhalo',
      ssoRegistrationDisabled: 'SSO registrácia je zakázaná administrátorom',
      tooManyFailedAttempts: 'Príliš veľa neúspešných pokusov - skúste to neskôr',
      unknownError: 'Neznáma chyba, skúste neskôr',
      usernameAlreadyInUse: 'Používateľské meno je už používané',
      weakPassword: 'Použite silnejšie heslo',
    },
  },
};

export { error as default };
